{
  "version": "2.0",
  "generatedAt": "2026-03-04T10:20:55.089Z",
  "totalBlocks": 199,
  "categories": [
    {
      "id": "auth",
      "label": "Authentication",
      "description": "Login, signup, password reset, and verification pages",
      "blocks": [
        {
          "id": "forgot-password",
          "category": "auth",
          "description": "Password reset page with email input, send reset link button, success state, and back to login link",
          "rendererTypes": [
            "button",
            "container",
            "form",
            "icon",
            "input",
            "label",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "auth",
            "forgot-password",
            "reset",
            "form"
          ],
          "complexity": "medium"
        },
        {
          "id": "login",
          "category": "auth",
          "description": "Login page with email/password form, social login options, remember me, and forgot password link",
          "rendererTypes": [
            "button",
            "checkbox",
            "container",
            "form",
            "icon",
            "input",
            "label",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "auth",
            "login",
            "sign-in",
            "form",
            "social",
            "oauth"
          ],
          "complexity": "medium"
        },
        {
          "id": "oauth-callback",
          "category": "auth",
          "description": "OAuth callback loading screen with spinner, connecting account message, and animated entrance",
          "rendererTypes": [
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "auth",
            "oauth",
            "loading",
            "callback",
            "social"
          ],
          "complexity": "medium"
        },
        {
          "id": "signup",
          "category": "auth",
          "description": "Registration page with name, email, password fields, strength indicator, terms checkbox, and social signup",
          "rendererTypes": [
            "button",
            "checkbox",
            "container",
            "form",
            "icon",
            "input",
            "label",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "auth",
            "signup",
            "register",
            "form",
            "social",
            "password-strength"
          ],
          "complexity": "high"
        },
        {
          "id": "social-auth-buttons",
          "category": "auth",
          "description": "Social authentication buttons for Google, GitHub, and Apple with divider, loading state, and error handling.",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "auth",
            "social",
            "oauth",
            "google",
            "github",
            "apple",
            "buttons"
          ],
          "complexity": "medium"
        },
        {
          "id": "split-auth",
          "category": "auth",
          "description": "Split-screen authentication layout with gradient branding panel (testimonial quote) on left and switchable login/signup form on right.",
          "rendererTypes": [
            "avatar",
            "button",
            "container",
            "icon",
            "input",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "auth",
            "split-screen",
            "branding",
            "login",
            "signup",
            "testimonial",
            "gradient"
          ],
          "complexity": "complex"
        },
        {
          "id": "verify-email",
          "category": "auth",
          "description": "Email verification page with envelope icon, check-your-email heading, resend button, and animated entrance",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "auth",
            "verify",
            "email",
            "confirmation"
          ],
          "complexity": "low"
        }
      ]
    },
    {
      "id": "blog",
      "label": "Blog",
      "description": "Blog listing, detail, sidebar, author, and comment components",
      "blocks": [
        {
          "id": "blog-author",
          "category": "blog",
          "description": "Author bio card with large avatar, name, bio, social links, article count, horizontal desktop layout",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-newsletter"
            ],
            "standalone": false
          },
          "tags": [
            "blog",
            "author",
            "bio",
            "profile",
            "social"
          ],
          "complexity": "medium"
        },
        {
          "id": "blog-comment",
          "category": "blog",
          "description": "Comment section with threaded comments, nested replies, avatar, date, reply button, and add-comment form",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "form",
            "input",
            "section",
            "separator",
            "text",
            "textarea"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-newsletter"
            ],
            "standalone": false
          },
          "tags": [
            "blog",
            "comments",
            "replies",
            "thread",
            "discussion"
          ],
          "complexity": "high"
        },
        {
          "id": "blog-detail",
          "category": "blog",
          "description": "Blog post detail page with hero image, title, author info, reading time, rich content, share buttons, and tags",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "image",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-newsletter"
            ],
            "standalone": false
          },
          "tags": [
            "blog",
            "article",
            "detail",
            "post",
            "reading",
            "share"
          ],
          "complexity": "medium"
        },
        {
          "id": "blog-list",
          "category": "blog",
          "description": "Blog post listing page with responsive 3-column card grid. Each card shows thumbnail, category badge, title, excerpt, author avatar, date, and read time. Stagger animation on entry.",
          "rendererTypes": [
            "avatar",
            "badge",
            "card",
            "container",
            "icon",
            "image",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-newsletter"
            ],
            "standalone": false
          },
          "tags": [
            "blog",
            "list",
            "posts",
            "grid",
            "cards",
            "responsive"
          ],
          "complexity": "high"
        },
        {
          "id": "blog-sidebar",
          "category": "blog",
          "description": "Blog sidebar with search, categories list, recent posts, tags cloud, and newsletter CTA",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "form",
            "icon",
            "input",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-newsletter"
            ],
            "standalone": false
          },
          "tags": [
            "blog",
            "sidebar",
            "search",
            "categories",
            "tags",
            "newsletter"
          ],
          "complexity": "high"
        }
      ]
    },
    {
      "id": "card",
      "label": "Card Components",
      "description": "Reusable card variants for profiles, products, stats, and actions",
      "blocks": [
        {
          "id": "agent-card",
          "category": "card",
          "description": "Agent Card block for realestate domain",
          "rendererTypes": [
            "avatar",
            "button",
            "card",
            "container",
            "icon",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "realestate",
            "agent",
            "card"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-action",
          "category": "card",
          "description": "Action card grid with colored icon circles, title, description, and animated arrow-right links. Group-hover arrow translation effect.",
          "rendererTypes": [
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "feature-grid",
              "cta-inline",
              "testimonial-grid"
            ],
            "standalone": false
          },
          "tags": [
            "card",
            "action",
            "icon",
            "cta",
            "grid",
            "hover",
            "arrow",
            "features"
          ],
          "complexity": "high"
        },
        {
          "id": "card-glass",
          "category": "card",
          "description": "Glassmorphism feature cards with backdrop blur, inset shadow, staggered enter animation, and hover lift effect. 3-card responsive grid for SaaS feature showcases.",
          "rendererTypes": [
            "badge",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "feature-grid",
              "cta-inline",
              "testimonial-grid"
            ],
            "standalone": false
          },
          "tags": [
            "card",
            "glass",
            "glassmorphism",
            "backdrop-blur",
            "interactive",
            "features",
            "saas"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-product",
          "category": "card",
          "description": "E-commerce product card grid with image, title, price with strikethrough original price, star rating, and add-to-cart button. Hover scale effect.",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "feature-grid",
              "cta-inline",
              "testimonial-grid"
            ],
            "standalone": false
          },
          "tags": [
            "card",
            "product",
            "ecommerce",
            "price",
            "rating",
            "shopping",
            "grid",
            "hover"
          ],
          "complexity": "high"
        },
        {
          "id": "card-profile",
          "category": "card",
          "description": "Team member profile card grid with avatar, name, role, bio, and social links. Hover lift animation.",
          "rendererTypes": [
            "avatar",
            "badge",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "feature-grid",
              "cta-inline",
              "testimonial-grid"
            ],
            "standalone": false
          },
          "tags": [
            "card",
            "profile",
            "team",
            "avatar",
            "social",
            "bio",
            "hover"
          ],
          "complexity": "high"
        },
        {
          "id": "card-stat",
          "category": "card",
          "description": "Statistics metric card grid with large number display, label, trend indicator with arrow icon and percentage change. Color-coded positive/negative trends.",
          "rendererTypes": [
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "feature-grid",
              "cta-inline",
              "testimonial-grid"
            ],
            "standalone": false
          },
          "tags": [
            "card",
            "stat",
            "metrics",
            "dashboard",
            "kpi",
            "trend",
            "analytics"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-style-overview",
          "category": "card",
          "description": "Design system style overview card showing typography specimen title and 12 color swatches in a 6-column grid with variable name labels.",
          "rendererTypes": [
            "card",
            "container",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "card-stat",
              "card-profile"
            ],
            "standalone": true
          },
          "tags": [
            "card",
            "design-system",
            "color",
            "swatch",
            "theme",
            "typography",
            "preview"
          ],
          "complexity": "simple"
        },
        {
          "id": "card-activate-agent",
          "category": "card",
          "description": "Agent activation card listing three AI-powered features with check icons, an alert with trial credit info, and cancel/enable action buttons.",
          "rendererTypes": [
            "alert",
            "alert-description",
            "badge",
            "button",
            "card",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "icon",
            "item",
            "item-content",
            "item-group",
            "item-media",
            "item-title"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "agent",
            "ai",
            "activation",
            "features",
            "dialog"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-analytics",
          "category": "card",
          "description": "Analytics card with a visitor count, percentage badge, View Analytics button, and an area chart showing monthly visitor data.",
          "rendererTypes": [
            "badge",
            "button",
            "card",
            "card-action",
            "card-description",
            "card-header",
            "card-title",
            "chart",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "analytics",
            "chart",
            "area",
            "visitors",
            "statistics",
            "badge"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-anomaly-alert",
          "category": "card",
          "description": "Anomaly alert empty-state card prompting users to upgrade for automatic anomaly monitoring with a CTA button.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "empty",
            "empty-content",
            "empty-description",
            "empty-header",
            "empty-title"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "anomaly",
            "alert",
            "empty-state",
            "observability",
            "monitoring",
            "upgrade"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-bar-chart",
          "category": "card",
          "description": "Bar chart card showing monthly desktop vs mobile traffic with a grouped bar chart, summary statistics grid, and a view report button.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "chart",
            "container",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "chart",
            "bar-chart",
            "analytics",
            "traffic",
            "statistics"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-book-appointment",
          "category": "card",
          "description": "Appointment booking card with doctor info, time slot toggle buttons, new patient alert, and book button.",
          "rendererTypes": [
            "alert",
            "alert-description",
            "alert-title",
            "button",
            "card",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "field",
            "field-group",
            "field-label",
            "toggle-group",
            "toggle-group-item"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "appointment",
            "booking",
            "medical",
            "time-slot",
            "alert"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-codespaces",
          "category": "card",
          "description": "GitHub Codespaces card with tabs (Codespaces/Local), empty state with Create Codespace button, separator, usage notice, and Local tab with HTTPS/SSH/CLI clone inputs and action buttons.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "container",
            "empty",
            "empty-content",
            "empty-description",
            "empty-header",
            "empty-icon",
            "empty-title",
            "field",
            "field-description",
            "field-label",
            "icon",
            "input",
            "input-group",
            "input-group-addon",
            "item",
            "item-actions",
            "item-content",
            "item-description",
            "item-title",
            "link",
            "separator",
            "tabs",
            "tabs-content",
            "tabs-list",
            "tabs-trigger",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "codespaces",
            "github",
            "tabs",
            "clone",
            "repository",
            "developer"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-contributions-activity",
          "category": "card",
          "description": "Contributions and activity settings card with a checkbox to make profile private, descriptive text, and a Save Changes button.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "checkbox",
            "field",
            "field-content",
            "field-description",
            "field-group",
            "field-label",
            "field-legend",
            "field-set",
            "form",
            "input"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "contributions",
            "activity",
            "settings",
            "checkbox",
            "form",
            "privacy",
            "github"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-contributors",
          "category": "card",
          "description": "Contributors card with title badge count, a wrapped grid of grayscale GitHub avatars, and a link to view more.",
          "rendererTypes": [
            "avatar",
            "badge",
            "card",
            "card-content",
            "card-footer",
            "card-header",
            "card-title",
            "container",
            "link",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "contributors",
            "avatar",
            "github",
            "team",
            "open-source"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-environment-variables",
          "category": "card",
          "description": "Environment variables card showing a list of key-value pairs with masked/visible values and edit/deploy action buttons.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "container",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "environment",
            "variables",
            "config",
            "settings",
            "deploy"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-feedback-form",
          "category": "card",
          "description": "Feedback form card with topic select dropdown, feedback textarea, and submit button.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "card-footer",
            "field",
            "field-group",
            "field-label",
            "select",
            "textarea"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "form",
            "feedback",
            "select",
            "textarea",
            "submit"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-file-upload",
          "category": "card",
          "description": "File upload card with a dashed-border drop zone, upload icon, supported file types description, and a Browse Files button.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "card-description",
            "card-header",
            "card-title",
            "empty",
            "empty-content",
            "empty-description",
            "empty-header",
            "empty-icon",
            "empty-title",
            "icon"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "file",
            "upload",
            "drag-drop",
            "empty-state",
            "cloud"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-github-profile",
          "category": "card",
          "description": "GitHub profile form card with name input, public email select, bio textarea with field descriptions, and save button.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "field",
            "field-description",
            "field-group",
            "field-label",
            "input",
            "select",
            "textarea"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "form",
            "profile",
            "github",
            "input",
            "select",
            "textarea"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-icon-preview-grid",
          "category": "card",
          "description": "Icon preview grid card displaying 16 common icons in an 8-column grid layout, each icon centered in a ring-bordered cell.",
          "rendererTypes": [
            "card",
            "card-content",
            "container",
            "icon"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "icon",
            "grid",
            "preview",
            "design-system"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-invite-team",
          "category": "card",
          "description": "Team invitation card with email input rows, role selects, an add-another button, invite link with copy action, and a send invites button.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "container",
            "field",
            "field-label",
            "input",
            "input-group",
            "input-group-addon",
            "select",
            "separator"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "team",
            "invite",
            "collaboration",
            "form",
            "email"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-invoice",
          "category": "card",
          "description": "Invoice card with header (invoice number, due date, pending badge), table of line items with subtotal/tax/total rows, and footer with Download PDF and Pay Now buttons.",
          "rendererTypes": [
            "badge",
            "button",
            "card",
            "card-action",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "table",
            "table-body",
            "table-cell",
            "table-head",
            "table-header",
            "table-row"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "invoice",
            "table",
            "payment",
            "finance",
            "billing"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-live-waveform",
          "category": "card",
          "description": "Live audio waveform card with a static waveform visualization placeholder and controls for Start Listening, Start Processing, and mode toggle.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "container",
            "waveform"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "audio",
            "waveform",
            "live",
            "microphone",
            "visualization",
            "media"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-no-team-members",
          "category": "card",
          "description": "Empty state card with grayscale avatar group, title, description, and invite button for when no team members exist.",
          "rendererTypes": [
            "avatar",
            "avatar-group",
            "button",
            "card",
            "card-content",
            "empty",
            "empty-content",
            "empty-description",
            "empty-header",
            "empty-icon",
            "empty-title"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "empty-state",
            "team",
            "avatar",
            "invite",
            "placeholder"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-not-found",
          "category": "card",
          "description": "404 Not Found empty-state card with a search input, keyboard shortcut indicator, and a link to the homepage.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "empty",
            "empty-content",
            "empty-description",
            "empty-header",
            "empty-title",
            "icon",
            "input",
            "input-group",
            "kbd"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "404",
            "not-found",
            "empty-state",
            "search",
            "error",
            "navigation"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-observability",
          "category": "card",
          "description": "Observability monitoring card with a hero image overlay using primary color mix-blend, title, description, create query button with plus icon, and a warning badge.",
          "rendererTypes": [
            "badge",
            "button",
            "card",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "container",
            "image"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "observability",
            "monitoring",
            "dashboard",
            "hero-image",
            "badge"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-pie-chart",
          "category": "card",
          "description": "Pie chart card showing browser visitor share with donut chart, legend, top browser badge, and progress bar footer.",
          "rendererTypes": [
            "badge",
            "card",
            "card-action",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "chart",
            "container",
            "progress",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "chart",
            "pie",
            "donut",
            "analytics",
            "browser",
            "statistics"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-report-bug",
          "category": "card",
          "description": "Bug report form card with title input, severity and component selects, steps-to-reproduce textarea, and submit/attach buttons.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "container",
            "field",
            "field-group",
            "field-label",
            "input",
            "select",
            "textarea"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "form",
            "bug-report",
            "input",
            "select",
            "textarea"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-shipping-address",
          "category": "card",
          "description": "Shipping address form card with street, apt/suite, city, state select, ZIP code, country select, a save-as-default checkbox, and cancel/save buttons.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "checkbox",
            "field",
            "field-group",
            "field-label",
            "input",
            "select"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "form",
            "shipping",
            "address",
            "ecommerce",
            "checkout"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-shortcuts",
          "category": "card",
          "description": "Keyboard shortcuts card listing common shortcuts with key badge indicators, separated by dividers.",
          "rendererTypes": [
            "card",
            "card-content",
            "item",
            "item-actions",
            "item-group",
            "item-header",
            "item-separator",
            "item-title",
            "kbd",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "shortcuts",
            "keyboard",
            "keys",
            "hotkeys",
            "productivity"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-skeleton-loading",
          "category": "card",
          "description": "Skeleton loading card showing placeholder shapes for avatar, text lines, and action buttons while content loads.",
          "rendererTypes": [
            "card",
            "card-content",
            "container",
            "skeleton"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "skeleton",
            "loading",
            "placeholder",
            "shimmer"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-sleep-report",
          "category": "card",
          "description": "Sleep report card with stacked bar chart of deep/light/REM sleep phases, stat grid, quality badge, and details button.",
          "rendererTypes": [
            "badge",
            "button",
            "card",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "chart",
            "container",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "chart",
            "bar",
            "sleep",
            "health",
            "report",
            "statistics"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-typography-specimen",
          "category": "card",
          "description": "Typography specimen card showing font family label, heading with rhythm text, two body paragraphs, and a full-width Share Feedback button in the footer.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "card-footer",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "typography",
            "font",
            "specimen",
            "preview",
            "feedback",
            "design-system"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-ui-elements",
          "category": "card",
          "description": "UI elements showcase card with buttons (default, secondary, outline, ghost), an item row with enable action, slider, input with search icon, textarea, badges, radio group, checkboxes, alert dialog trigger, button group, and switch.",
          "rendererTypes": [
            "alert-dialog",
            "alert-dialog-action",
            "alert-dialog-cancel",
            "alert-dialog-content",
            "alert-dialog-description",
            "alert-dialog-footer",
            "alert-dialog-header",
            "alert-dialog-title",
            "alert-dialog-trigger",
            "badge",
            "button",
            "button-group",
            "card",
            "card-content",
            "checkbox",
            "container",
            "dropdown-menu",
            "dropdown-menu-content",
            "dropdown-menu-group",
            "dropdown-menu-item",
            "dropdown-menu-label",
            "dropdown-menu-separator",
            "dropdown-menu-trigger",
            "field",
            "field-group",
            "icon",
            "input",
            "input-group",
            "input-group-addon",
            "item",
            "item-actions",
            "item-content",
            "item-description",
            "item-title",
            "radio-group",
            "radio-group-item",
            "slider",
            "switch",
            "textarea"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "ui",
            "elements",
            "showcase",
            "button",
            "input",
            "badge",
            "slider",
            "switch",
            "checkbox",
            "radio"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-usage",
          "category": "card",
          "description": "Usage card showing billing cycle countdown with a list of usage items, each displaying a circular gauge, item name, and cost/value.",
          "rendererTypes": [
            "card",
            "card-content",
            "card-header",
            "card-title",
            "item",
            "item-actions",
            "item-content",
            "item-group",
            "item-media",
            "item-title",
            "ring-progress",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "usage",
            "billing",
            "gauge",
            "list",
            "pricing",
            "metrics"
          ],
          "complexity": "complex"
        },
        {
          "id": "card-visitors",
          "category": "card",
          "description": "Visitors card with a 6-month area chart, trend percentage badge, and full-width chart below the header.",
          "rendererTypes": [
            "badge",
            "card",
            "card-action",
            "card-content",
            "card-description",
            "card-header",
            "card-title",
            "chart"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "visitors",
            "chart",
            "area",
            "analytics",
            "trend",
            "badge"
          ],
          "complexity": "medium"
        },
        {
          "id": "card-weekly-fitness-summary",
          "category": "card",
          "description": "Weekly fitness summary card with a 7-column bar chart showing daily workout load percentages, plus a View Details button footer.",
          "rendererTypes": [
            "button",
            "card",
            "card-content",
            "card-description",
            "card-footer",
            "card-header",
            "card-title",
            "container",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "card",
            "fitness",
            "weekly",
            "chart",
            "bar",
            "health",
            "workout",
            "summary"
          ],
          "complexity": "complex"
        }
      ]
    },
    {
      "id": "crm",
      "label": "CRM",
      "description": "Customer relationship management components including pipelines and activity tracking",
      "blocks": [
        {
          "id": "activity-timeline",
          "category": "crm",
          "description": "CRM activity feed with vertical timeline connector lines. Supports call, email, meeting, and note activity types. Each entry shows typed icon with status dot, title, description, timestamp, and user avatar. Includes filter tabs and load-more pagination.",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "flex",
            "icon",
            "section",
            "tab-trigger",
            "tabs",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "crm",
            "timeline",
            "activity",
            "feed",
            "calls",
            "emails",
            "meetings",
            "notes",
            "history"
          ],
          "complexity": "complex"
        },
        {
          "id": "pipeline-board",
          "category": "crm",
          "description": "CRM Kanban pipeline board with 4 deal stages (Lead, Qualified, Proposal, Won). Each column shows count badge, colored header dot, and draggable deal cards with company name, contact avatar, deal value, and expected close date. Includes filter, sort, and add-deal controls.",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "flex",
            "icon",
            "progress",
            "section",
            "select",
            "separator",
            "tab-trigger",
            "tabs",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "crm",
            "kanban",
            "pipeline",
            "deals",
            "board",
            "drag-drop",
            "sales",
            "stages"
          ],
          "complexity": "complex"
        }
      ]
    },
    {
      "id": "cta",
      "label": "Call-to-Action",
      "description": "Conversion-focused banner, gradient, inline, newsletter, and split sections",
      "blocks": [
        {
          "id": "cta-banner",
          "category": "cta",
          "description": "Simple full-width banner CTA with primary background color, short text on left, and button on right. Stacks on mobile.",
          "rendererTypes": [
            "button",
            "container",
            "section",
            "text"
          ],
          "composability": {
            "position": "bottom",
            "pairs_with": [
              "footer-multi-column",
              "footer-minimal",
              "testimonial-carousel"
            ],
            "standalone": false
          },
          "tags": [
            "cta",
            "banner",
            "full-width",
            "primary",
            "simple",
            "responsive"
          ],
          "complexity": "low"
        },
        {
          "id": "cta-gradient",
          "category": "cta",
          "description": "Full-width call-to-action section with gradient background, gradient text title, blur-orb decoration, dual CTAs, and staggered reveals",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "input",
            "section",
            "text"
          ],
          "composability": {
            "position": "bottom",
            "pairs_with": [
              "footer-multi-column",
              "footer-minimal",
              "testimonial-carousel"
            ],
            "standalone": false
          },
          "tags": [
            "cta",
            "gradient",
            "gradient-text",
            "blur-orb",
            "call-to-action"
          ],
          "complexity": "medium"
        },
        {
          "id": "cta-inline",
          "category": "cta",
          "description": "Compact inline CTA card with border, icon, headline, description, and button. Designed for embedding within page content. Hover shadow interaction.",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "bottom",
            "pairs_with": [
              "footer-multi-column",
              "footer-minimal",
              "testimonial-carousel"
            ],
            "standalone": false
          },
          "tags": [
            "cta",
            "inline",
            "card",
            "compact",
            "border",
            "embed",
            "hover"
          ],
          "complexity": "low"
        },
        {
          "id": "cta-newsletter",
          "category": "cta",
          "description": "Newsletter subscription CTA with email input, submit button, privacy note, and subscriber count trust signal. Has localState for email and form submission flow.",
          "rendererTypes": [
            "avatar",
            "button",
            "container",
            "icon",
            "input",
            "section",
            "text"
          ],
          "composability": {
            "position": "bottom",
            "pairs_with": [
              "footer-multi-column",
              "footer-minimal",
              "testimonial-carousel"
            ],
            "standalone": false
          },
          "tags": [
            "cta",
            "newsletter",
            "email",
            "subscription",
            "form",
            "trust",
            "input"
          ],
          "complexity": "medium"
        },
        {
          "id": "cta-split",
          "category": "cta",
          "description": "Split CTA with illustration/image panel on the left and text + button on the right. Blur-orb decorations. Slide-in animation from sides.",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "bottom",
            "pairs_with": [
              "footer-multi-column",
              "footer-minimal",
              "testimonial-carousel"
            ],
            "standalone": false
          },
          "tags": [
            "cta",
            "split",
            "grid",
            "illustration",
            "blur-orb",
            "animation",
            "slideIn"
          ],
          "complexity": "medium"
        }
      ]
    },
    {
      "id": "data-display",
      "label": "Data Display",
      "description": "Charts, tables, metrics, media players, galleries, and feedback components",
      "blocks": [
        {
          "id": "activity-feed",
          "category": "data-display",
          "description": "Activity feed timeline with colored icon indicators, hover states, and activity detail navigation",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "saas",
            "activity",
            "feed",
            "timeline",
            "recent"
          ],
          "complexity": "complex"
        },
        {
          "id": "alert-toast",
          "category": "data-display",
          "description": "Alert Toast block for feedback domain",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "feedback",
            "alert",
            "toast"
          ],
          "complexity": "medium"
        },
        {
          "id": "analytics-filter-bar",
          "category": "data-display",
          "description": "Analytics filter bar with date range picker, metric selector, granularity, and compare toggle",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "input",
            "select",
            "switch",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "saas",
            "analytics",
            "filter",
            "bar",
            "date-range"
          ],
          "complexity": "medium"
        },
        {
          "id": "audio-player",
          "category": "data-display",
          "description": "Audio Player block for media domain",
          "rendererTypes": [
            "button",
            "container",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "media",
            "audio",
            "player"
          ],
          "complexity": "complex"
        },
        {
          "id": "dashboard-charts",
          "category": "data-display",
          "description": "2-column chart layout with line chart (revenue over time), bar chart (users by category), tab controls for time ranges, and progress indicators",
          "rendererTypes": [
            "badge",
            "card",
            "chart",
            "container",
            "progress",
            "section",
            "tab-trigger",
            "tabs",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "dashboard-sidebar",
              "dashboard-header",
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "charts",
            "line-chart",
            "bar-chart",
            "analytics",
            "tabs",
            "progress",
            "dashboard"
          ],
          "complexity": "high"
        },
        {
          "id": "dashboard-stats",
          "category": "data-display",
          "description": "4-column responsive stats grid with KPI cards showing icon, title, value, and trend indicator with staggered entrance animations",
          "rendererTypes": [
            "card",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "dashboard-sidebar",
              "dashboard-header",
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "stats",
            "kpi",
            "cards",
            "metrics",
            "analytics",
            "dashboard",
            "responsive"
          ],
          "complexity": "medium"
        },
        {
          "id": "dashboard-table",
          "category": "data-display",
          "description": "Data table section with recent orders, status badges, sortable columns, and pagination controls",
          "rendererTypes": [
            "button",
            "card",
            "container",
            "icon",
            "pagination",
            "section",
            "table",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "dashboard-sidebar",
              "dashboard-header",
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "table",
            "data-table",
            "orders",
            "pagination",
            "badges",
            "dashboard"
          ],
          "complexity": "medium"
        },
        {
          "id": "data-list",
          "category": "data-display",
          "description": "Vertical list of items each with an icon, title, description, and optional action button. Supports stagger scroll-reveal animation and separator lines between items.",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "dashboard-sidebar",
              "dashboard-header",
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "list",
            "items",
            "icon",
            "stagger",
            "animation",
            "vertical"
          ],
          "complexity": "high"
        },
        {
          "id": "data-metric",
          "category": "data-display",
          "description": "Metric dashboard section displaying 4 key KPIs in a responsive grid. Each metric card shows a large number, descriptive label, percentage change, and trend arrow (up/down). Scroll-reveal animation.",
          "rendererTypes": [
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "dashboard-sidebar",
              "dashboard-header",
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "metric",
            "kpi",
            "stats",
            "dashboard",
            "trend",
            "number"
          ],
          "complexity": "medium"
        },
        {
          "id": "empty-state",
          "category": "data-display",
          "description": "Empty State block for feedback domain",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "feedback",
            "empty",
            "state"
          ],
          "complexity": "medium"
        },
        {
          "id": "image-gallery",
          "category": "data-display",
          "description": "Image Gallery block for media domain",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "input",
            "list",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "media",
            "image",
            "gallery"
          ],
          "complexity": "complex"
        },
        {
          "id": "location-map",
          "category": "data-display",
          "description": "Restaurant location and contact section with map image placeholder, pin marker, fullscreen button, info card with restaurant name, address, hours, open/closed badge, phone, and action buttons (Get Directions, Call). Based on 21st.dev ContactCard pattern with icon-labeled contact info items and grid layout.",
          "rendererTypes": [
            "badge",
            "button",
            "card",
            "container",
            "icon",
            "image",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "restaurant",
            "location",
            "map",
            "contact",
            "directions"
          ],
          "complexity": "complex"
        },
        {
          "id": "map-view",
          "category": "data-display",
          "description": "Map View block for realestate domain",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "select",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "realestate",
            "map",
            "view"
          ],
          "complexity": "complex"
        },
        {
          "id": "media-grid",
          "category": "data-display",
          "description": "Media Grid block for media domain",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "image",
            "input",
            "list",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "media",
            "grid"
          ],
          "complexity": "complex"
        },
        {
          "id": "modal-dialog",
          "category": "data-display",
          "description": "Modal Dialog block for feedback domain",
          "rendererTypes": [
            "button",
            "container",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "feedback",
            "modal",
            "dialog"
          ],
          "complexity": "complex"
        },
        {
          "id": "notification-center",
          "category": "data-display",
          "description": "Notification Center block for feedback domain",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "image",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "feedback",
            "notification",
            "center"
          ],
          "complexity": "complex"
        },
        {
          "id": "progress-indicator",
          "category": "data-display",
          "description": "Progress Indicator block for feedback domain",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "feedback",
            "progress",
            "indicator"
          ],
          "complexity": "complex"
        },
        {
          "id": "showcase-feedback",
          "category": "data-display",
          "description": "Feedback and status elements showcase with alerts, progress bars, skeleton loaders, and accordions",
          "rendererTypes": [
            "accordion",
            "alert",
            "badge",
            "container",
            "progress",
            "section",
            "skeleton",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "dashboard-sidebar",
              "dashboard-header",
              "footer-minimal"
            ],
            "standalone": true
          },
          "tags": [
            "alert",
            "progress",
            "skeleton",
            "accordion",
            "feedback",
            "status"
          ],
          "complexity": "high"
        },
        {
          "id": "survey-results",
          "category": "data-display",
          "description": "Survey results page with score display and feedback summary",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "survey",
            "results"
          ],
          "complexity": "complex"
        },
        {
          "id": "toast-stack",
          "category": "data-display",
          "description": "Toast Stack block for feedback domain",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "feedback",
            "toast",
            "stack"
          ],
          "complexity": "medium"
        },
        {
          "id": "video-player",
          "category": "data-display",
          "description": "Video Player block for media domain",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "image",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "data-display",
            "media",
            "video",
            "player"
          ],
          "complexity": "complex"
        }
      ]
    },
    {
      "id": "ecommerce",
      "label": "E-Commerce",
      "description": "Product cards, carts, checkout, categories, and search results",
      "blocks": [
        {
          "id": "cart-sidebar",
          "category": "ecommerce",
          "description": "Shopping cart sidebar with item rows, quantity selectors, remove buttons, subtotal and checkout CTA",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-banner"
            ],
            "standalone": false
          },
          "tags": [
            "ecommerce",
            "cart",
            "sidebar",
            "checkout",
            "shopping"
          ],
          "complexity": "high"
        },
        {
          "id": "category-grid",
          "category": "ecommerce",
          "description": "Product category browsing grid with filter sidebar, sort dropdown, result count, and staggered product cards",
          "rendererTypes": [
            "button",
            "checkbox",
            "container",
            "icon",
            "image",
            "section",
            "select",
            "separator",
            "slider",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-banner"
            ],
            "standalone": false
          },
          "tags": [
            "ecommerce",
            "category",
            "grid",
            "filter",
            "sort",
            "browse"
          ],
          "complexity": "high"
        },
        {
          "id": "checkout-form",
          "category": "ecommerce",
          "description": "Checkout form with shipping info, payment method, order summary, and submit order flow",
          "rendererTypes": [
            "button",
            "container",
            "form",
            "icon",
            "image",
            "input",
            "label",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-banner"
            ],
            "standalone": false
          },
          "tags": [
            "ecommerce",
            "checkout",
            "form",
            "payment",
            "shipping",
            "order"
          ],
          "complexity": "high"
        },
        {
          "id": "menu-grid",
          "category": "ecommerce",
          "description": "Restaurant menu card grid with dish images, names, descriptions, dietary badges (Vegan, GF), prices, category filter tabs, and hover interactions. Uses $ref/definitions for repeated menu-item cards. Based on 21st.dev MenuItemCard pattern with image, price, prep time, and add-to-cart hover button.",
          "rendererTypes": [
            "badge",
            "button",
            "card",
            "container",
            "image",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "ecommerce",
            "restaurant",
            "menu",
            "grid",
            "food",
            "cards"
          ],
          "complexity": "complex"
        },
        {
          "id": "order-summary",
          "category": "ecommerce",
          "description": "Order confirmation page with success checkmark, order number, estimated delivery, item summary, and continue shopping CTA",
          "rendererTypes": [
            "button",
            "card",
            "container",
            "icon",
            "image",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-banner"
            ],
            "standalone": false
          },
          "tags": [
            "ecommerce",
            "order",
            "confirmation",
            "success",
            "receipt"
          ],
          "complexity": "high"
        },
        {
          "id": "product-card",
          "category": "ecommerce",
          "description": "Reusable product card with image, title, price, rating, add-to-cart button, and sale badge overlay",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-banner"
            ],
            "standalone": false
          },
          "tags": [
            "ecommerce",
            "product",
            "card",
            "shop",
            "cart",
            "rating",
            "badge"
          ],
          "complexity": "high"
        },
        {
          "id": "product-detail",
          "category": "ecommerce",
          "description": "Product detail page with image gallery, title, price, size/color selectors, quantity, tabs for description/reviews/shipping",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "separator",
            "tab-trigger",
            "tabs",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-banner"
            ],
            "standalone": false
          },
          "tags": [
            "ecommerce",
            "product",
            "detail",
            "gallery",
            "tabs",
            "selector"
          ],
          "complexity": "high"
        },
        {
          "id": "property-detail",
          "category": "ecommerce",
          "description": "Property Detail block for realestate domain",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "card",
            "container",
            "icon",
            "image",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "ecommerce",
            "realestate",
            "property",
            "detail"
          ],
          "complexity": "complex"
        },
        {
          "id": "property-grid",
          "category": "ecommerce",
          "description": "Property Grid block for realestate domain",
          "rendererTypes": [
            "badge",
            "button",
            "card",
            "container",
            "icon",
            "image",
            "select",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "ecommerce",
            "realestate",
            "property",
            "grid"
          ],
          "complexity": "complex"
        },
        {
          "id": "search-results",
          "category": "ecommerce",
          "description": "Search results page with active query, result count, sort options, product grid/list toggle, and pagination",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "image",
            "section",
            "select",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-banner"
            ],
            "standalone": false
          },
          "tags": [
            "ecommerce",
            "search",
            "results",
            "pagination",
            "sort"
          ],
          "complexity": "high"
        },
        {
          "id": "wishlist",
          "category": "ecommerce",
          "description": "Wishlist page with saved product cards, heart toggle, move to cart button, and empty state CTA",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-banner"
            ],
            "standalone": false
          },
          "tags": [
            "ecommerce",
            "wishlist",
            "favorites",
            "heart",
            "saved"
          ],
          "complexity": "medium"
        }
      ]
    },
    {
      "id": "education",
      "label": "Education",
      "description": "Course cards, lessons, quizzes, enrollment, and student dashboards",
      "blocks": [
        {
          "id": "course-card",
          "category": "education",
          "description": "Course card grid for listings. Thumbnail, title, instructor avatar and name, star rating, student count, price badge, optional progress bar for enrolled courses, category badge.",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "progress",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "education",
            "course",
            "card",
            "listing",
            "rating",
            "progress"
          ],
          "complexity": "high"
        },
        {
          "id": "course-detail",
          "category": "education",
          "description": "Course detail page. Hero with video player area, title, instructor info, rating, enrollment count. Curriculum accordion (chapters and lessons). Includes and requirements lists. Enroll CTA.",
          "rendererTypes": [
            "accordion",
            "accordion-item",
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "education",
            "course",
            "detail",
            "curriculum",
            "accordion",
            "enroll"
          ],
          "complexity": "high"
        },
        {
          "id": "curriculum-outline",
          "category": "education",
          "description": "Curriculum Outline block for education domain",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "education",
            "curriculum",
            "outline"
          ],
          "complexity": "complex"
        },
        {
          "id": "enrollment-form",
          "category": "education",
          "description": "Course enrollment and purchase form. Course summary card, pricing options (one-time or subscription), payment method fields, terms checkbox, and enroll button.",
          "rendererTypes": [
            "button",
            "checkbox",
            "container",
            "form",
            "icon",
            "image",
            "input",
            "label",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "education",
            "enrollment",
            "form",
            "payment",
            "checkout",
            "purchase"
          ],
          "complexity": "high"
        },
        {
          "id": "instructor-card",
          "category": "education",
          "description": "Instructor Card block for education domain",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "education",
            "instructor",
            "card"
          ],
          "complexity": "complex"
        },
        {
          "id": "lesson-viewer",
          "category": "education",
          "description": "Lesson content viewer with video area, lesson title and description, sidebar lesson list with progress checkmarks",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "progress",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "education",
            "lesson",
            "video",
            "course",
            "progress",
            "sidebar"
          ],
          "complexity": "high"
        },
        {
          "id": "progress-tracker",
          "category": "education",
          "description": "Learning progress dashboard with overall progress ring, course progress list, and achievements/badges row",
          "rendererTypes": [
            "container",
            "icon",
            "progress",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "education",
            "progress",
            "achievements",
            "badges",
            "courses",
            "dashboard"
          ],
          "complexity": "high"
        },
        {
          "id": "quiz",
          "category": "education",
          "description": "Quiz question card with 4 answer options (radio in cards), progress bar, and Submit/Next button",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "progress",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "education",
            "quiz",
            "question",
            "assessment",
            "radio",
            "progress"
          ],
          "complexity": "medium"
        },
        {
          "id": "student-dashboard",
          "category": "education",
          "description": "Student learning dashboard. Progress overview stat cards, current courses with progress bars, upcoming deadlines list, and earned achievement badges.",
          "rendererTypes": [
            "container",
            "icon",
            "image",
            "progress",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-multi-column",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "education",
            "dashboard",
            "student",
            "progress",
            "achievements",
            "deadlines"
          ],
          "complexity": "high"
        }
      ]
    },
    {
      "id": "feature",
      "label": "Feature Sections",
      "description": "Bento, grid, icon, list, and comparison feature layouts",
      "blocks": [
        {
          "id": "feature-bento",
          "category": "feature",
          "description": "Asymmetric bento grid feature section with 5 cards, blur-orb featured card, Lucide icons, and staggered scale-in animations",
          "rendererTypes": [
            "badge",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "pricing-toggle",
              "pricing-cards",
              "testimonial-carousel",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "feature",
            "bento",
            "grid",
            "asymmetric",
            "icons",
            "blur-orb"
          ],
          "complexity": "high"
        },
        {
          "id": "feature-comparison",
          "category": "feature",
          "description": "Two-column comparison block (Basic vs Pro) with check and X icons for feature availability. Highlighted recommended column with border-primary.",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "pricing-toggle",
              "pricing-cards",
              "testimonial-carousel",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "feature",
            "comparison",
            "pricing",
            "check",
            "basic",
            "pro",
            "table",
            "highlight"
          ],
          "complexity": "high"
        },
        {
          "id": "feature-grid",
          "category": "feature",
          "description": "Simple 3x3 feature grid. Each cell has an icon, title, and description. Responsive 1→2→3 column layout with stagger animation.",
          "rendererTypes": [
            "badge",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "pricing-toggle",
              "pricing-cards",
              "testimonial-carousel",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "feature",
            "grid",
            "icon",
            "responsive",
            "stagger",
            "animation",
            "landing"
          ],
          "complexity": "medium"
        },
        {
          "id": "feature-icon",
          "category": "feature",
          "description": "Icon-focused feature showcase with large icons (48x48), bold titles, and short descriptions. Grid of 6 features with dot-pattern background and icon hover scale.",
          "rendererTypes": [
            "badge",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "pricing-toggle",
              "pricing-cards",
              "testimonial-carousel",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "feature",
            "icon",
            "showcase",
            "grid",
            "dot-pattern",
            "hover",
            "animation"
          ],
          "complexity": "medium"
        },
        {
          "id": "feature-list",
          "category": "feature",
          "description": "Vertical feature list with alternating layout — icon left, text right on odd rows; reversed on even rows at desktop. Scroll-triggered reveal per feature.",
          "rendererTypes": [
            "badge",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "pricing-toggle",
              "pricing-cards",
              "testimonial-carousel",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "feature",
            "list",
            "alternating",
            "scroll",
            "animation",
            "image",
            "two-column"
          ],
          "complexity": "high"
        }
      ]
    },
    {
      "id": "fitness",
      "label": "Fitness",
      "description": "fitness components",
      "blocks": [
        {
          "id": "diet-tracker",
          "category": "fitness",
          "description": "Meal logging interface with breakfast/lunch/dinner/snack sections, calorie progress bar, macronutrient breakdown (protein/carbs/fat) donut chart, and food item list",
          "rendererTypes": [
            "button",
            "card",
            "container",
            "flex",
            "grid",
            "icon",
            "progress",
            "radial-progress",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "fitness",
            "diet",
            "nutrition",
            "calories",
            "macros",
            "meal",
            "food",
            "tracker"
          ],
          "complexity": "complex"
        },
        {
          "id": "fitness-dashboard",
          "category": "fitness",
          "description": "Fitness dashboard with activity rings (steps, calories, distance, active minutes), daily goal progress, streak counter, and quick-start workout buttons",
          "rendererTypes": [
            "badge",
            "button",
            "card",
            "container",
            "flex",
            "grid",
            "icon",
            "progress",
            "radial-progress",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "fitness",
            "dashboard",
            "health",
            "activity-rings",
            "steps",
            "calories",
            "goals",
            "progress"
          ],
          "complexity": "complex"
        },
        {
          "id": "fitness-profile",
          "category": "fitness",
          "description": "User fitness profile with stats summary, workout streak counter, personal records section, and recent activity history list",
          "rendererTypes": [
            "avatar",
            "card",
            "container",
            "flex",
            "grid",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "fitness",
            "profile",
            "user",
            "stats",
            "streak",
            "records",
            "history",
            "achievements"
          ],
          "complexity": "complex"
        },
        {
          "id": "goal-setting",
          "category": "fitness",
          "description": "Fitness goal management with goal cards (weight, steps, workout frequency), target inputs, progress indicators, and achievement badges",
          "rendererTypes": [
            "card",
            "container",
            "flex",
            "grid",
            "icon",
            "progress",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "fitness",
            "goals",
            "targets",
            "achievements",
            "badges",
            "weight",
            "steps",
            "motivation"
          ],
          "complexity": "complex"
        },
        {
          "id": "progress-chart",
          "category": "fitness",
          "description": "Weight and activity progress charts over time with line/bar graphs, date range selector, stat comparison cards, and trend indicators",
          "rendererTypes": [
            "badge",
            "card",
            "chart",
            "container",
            "flex",
            "grid",
            "icon",
            "section",
            "tab-trigger",
            "tabs",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "fitness",
            "progress",
            "chart",
            "weight",
            "activity",
            "trends",
            "analytics",
            "history"
          ],
          "complexity": "complex"
        },
        {
          "id": "workout-detail",
          "category": "fitness",
          "description": "Exercise detail view with timer, rep counter, rest intervals, video placeholder, exercise steps list, and prev/next navigation",
          "rendererTypes": [
            "badge",
            "button",
            "card",
            "container",
            "flex",
            "grid",
            "icon",
            "progress",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "fitness",
            "workout",
            "exercise",
            "timer",
            "reps",
            "rest",
            "video",
            "detail"
          ],
          "complexity": "complex"
        },
        {
          "id": "workout-list",
          "category": "fitness",
          "description": "Exercise plan cards with difficulty badges, duration, target muscle groups, calorie estimate, and start workout button",
          "rendererTypes": [
            "badge",
            "button",
            "card",
            "container",
            "flex",
            "icon",
            "image",
            "section",
            "tab-trigger",
            "tabs",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "fitness",
            "workout",
            "exercise",
            "plan",
            "difficulty",
            "muscle-group",
            "training"
          ],
          "complexity": "complex"
        }
      ]
    },
    {
      "id": "food-delivery",
      "label": "Food Delivery",
      "description": "Restaurant browsing, menu items, cart, order tracking, and food search",
      "blocks": [
        {
          "id": "cart-summary",
          "category": "food-delivery",
          "description": "Order cart with items list, quantity controls, subtotal/delivery fee/total breakdown, and checkout button",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "input",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "food-delivery",
            "cart",
            "order",
            "checkout",
            "summary",
            "total"
          ],
          "complexity": "complex"
        },
        {
          "id": "food-home",
          "category": "food-delivery",
          "description": "Food delivery homepage with hero search banner, popular cuisine categories, and featured restaurant cards grid",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "input",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "food-delivery",
            "home",
            "hero",
            "search",
            "restaurants",
            "categories"
          ],
          "complexity": "complex"
        },
        {
          "id": "food-search",
          "category": "food-delivery",
          "description": "Search page with search bar, recent searches list, cuisine filter pills, and search results grid",
          "rendererTypes": [
            "container",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "food-delivery",
            "search",
            "filter",
            "results",
            "cuisine",
            "recent"
          ],
          "complexity": "medium"
        },
        {
          "id": "menu-item-card",
          "category": "food-delivery",
          "description": "Food menu item card with image, veg/non-veg badge, name, description, price, prep time, and add-to-cart button",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "food-delivery",
            "menu",
            "item",
            "card",
            "food",
            "add-to-cart",
            "veg"
          ],
          "complexity": "complex"
        },
        {
          "id": "order-tracking",
          "category": "food-delivery",
          "description": "Order status timeline with confirmed/preparing/on-the-way/delivered steps, driver info card, and map placeholder",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "food-delivery",
            "order",
            "tracking",
            "timeline",
            "status",
            "delivery",
            "driver"
          ],
          "complexity": "complex"
        },
        {
          "id": "restaurant-detail",
          "category": "food-delivery",
          "description": "Restaurant detail page with header info, menu category tabs, and scrollable menu items list with add-to-cart actions",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "image",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "food-delivery",
            "restaurant",
            "detail",
            "menu",
            "tabs",
            "order"
          ],
          "complexity": "complex"
        },
        {
          "id": "restaurant-list",
          "category": "food-delivery",
          "description": "Browse restaurants with cuisine, rating, and delivery time filters in a responsive card grid layout",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "select",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "food-delivery",
            "restaurant",
            "list",
            "filter",
            "grid",
            "browse"
          ],
          "complexity": "complex"
        }
      ]
    },
    {
      "id": "footer",
      "label": "Footer",
      "description": "Multi-column, minimal, social, branded, and CTA footer variants",
      "blocks": [
        {
          "id": "footer-branded",
          "category": "footer",
          "description": "Footer block for compositions domain",
          "rendererTypes": [
            "container",
            "icon",
            "link",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "bottom",
            "pairs_with": [
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "compositions",
            "footer"
          ],
          "complexity": "complex"
        },
        {
          "id": "footer-cta",
          "category": "footer",
          "description": "Footer with CTA section (heading + email input + subscribe button) above standard link columns, separated by a divider, with gradient background on CTA area",
          "rendererTypes": [
            "button",
            "container",
            "form",
            "icon",
            "input",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "bottom",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "footer",
            "cta",
            "email",
            "newsletter",
            "subscribe",
            "links"
          ],
          "complexity": "high"
        },
        {
          "id": "footer-minimal",
          "category": "footer",
          "description": "Minimal single-line footer with logo, copyright text, and 4 inline links in a flex justify-between layout with scroll-triggered fade animation",
          "rendererTypes": [
            "container",
            "icon",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "bottom",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "footer",
            "minimal",
            "simple",
            "links",
            "copyright"
          ],
          "complexity": "medium"
        },
        {
          "id": "footer-multi-column",
          "category": "footer",
          "description": "Multi-column footer with logo, social icons, 3 link groups, bottom bar with legal links, grid-lines background, and staggered column reveals",
          "rendererTypes": [
            "container",
            "icon",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "bottom",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "footer",
            "navigation",
            "links",
            "social",
            "multi-column",
            "grid-lines"
          ],
          "complexity": "medium"
        },
        {
          "id": "footer-social",
          "category": "footer",
          "description": "Social-media focused footer with large social icon row as primary element, hover scale and color interactions, minimal legal links below, and staggered fade animation",
          "rendererTypes": [
            "container",
            "icon",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "bottom",
            "pairs_with": [],
            "standalone": true
          },
          "tags": [
            "footer",
            "social",
            "icons",
            "github",
            "twitter",
            "linkedin",
            "minimal"
          ],
          "complexity": "medium"
        }
      ]
    },
    {
      "id": "form",
      "label": "Forms",
      "description": "Contact forms, login forms, file uploads, search filters, and wizards",
      "blocks": [
        {
          "id": "file-upload",
          "category": "form",
          "description": "File Upload block for media domain",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "list",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "form",
            "media",
            "file",
            "upload"
          ],
          "complexity": "complex"
        },
        {
          "id": "form-contact",
          "category": "form",
          "description": "Contact form with name, email, subject, and message textarea fields plus a submit button. Includes loading state and success feedback.",
          "rendererTypes": [
            "button",
            "container",
            "form",
            "icon",
            "input",
            "label",
            "section",
            "text",
            "textarea"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "hero-minimal",
              "cta-inline",
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "form",
            "contact",
            "email",
            "message",
            "submit",
            "validation"
          ],
          "complexity": "medium"
        },
        {
          "id": "form-login",
          "category": "form",
          "description": "Simple login form with email and password fields and a submit button. Lightweight version without social logins or remember-me options.",
          "rendererTypes": [
            "button",
            "checkbox",
            "container",
            "form",
            "icon",
            "input",
            "label",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "hero-minimal",
              "cta-inline",
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "form",
            "login",
            "auth",
            "email",
            "password",
            "signin"
          ],
          "complexity": "medium"
        },
        {
          "id": "image-upload",
          "category": "form",
          "description": "Image Upload block for media domain",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "image",
            "list",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "form",
            "media",
            "image",
            "upload"
          ],
          "complexity": "complex"
        },
        {
          "id": "mortgage-calc",
          "category": "form",
          "description": "Mortgage Calc block for realestate domain",
          "rendererTypes": [
            "badge",
            "button",
            "card",
            "container",
            "icon",
            "input",
            "select",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "form",
            "realestate",
            "mortgage",
            "calc"
          ],
          "complexity": "complex"
        },
        {
          "id": "question-wizard",
          "category": "form",
          "description": "Multi-step question wizard with slider, select, checkbox, and input types",
          "rendererTypes": [
            "button",
            "card",
            "container",
            "input",
            "separator",
            "tab-trigger",
            "tabs",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "form",
            "question",
            "wizard"
          ],
          "complexity": "complex"
        },
        {
          "id": "search-filters",
          "category": "form",
          "description": "Search Filters block for realestate domain",
          "rendererTypes": [
            "badge",
            "button",
            "card",
            "container",
            "icon",
            "input",
            "select",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "form",
            "realestate",
            "search",
            "filters"
          ],
          "complexity": "complex"
        },
        {
          "id": "showcase-forms-section",
          "category": "form",
          "description": "Comprehensive form elements showcase with contact form, settings controls, and all input variants",
          "rendererTypes": [
            "badge",
            "button",
            "checkbox",
            "container",
            "date-picker",
            "form",
            "icon",
            "input",
            "label",
            "radio",
            "section",
            "select",
            "slider",
            "switch",
            "text",
            "textarea",
            "tooltip"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "hero-minimal",
              "cta-inline",
              "footer-minimal"
            ],
            "standalone": true
          },
          "tags": [
            "form",
            "input",
            "select",
            "checkbox",
            "radio",
            "slider",
            "switch",
            "date-picker",
            "textarea",
            "tooltip"
          ],
          "complexity": "high"
        },
        {
          "id": "showcase-overlays",
          "category": "form",
          "description": "Overlay components showcase with dialog, sheet, popover, and alert-dialog elements",
          "rendererTypes": [
            "alert-dialog",
            "badge",
            "button",
            "container",
            "dialog",
            "icon",
            "input",
            "label",
            "popover",
            "section",
            "sheet",
            "switch",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "hero-minimal",
              "cta-inline",
              "footer-minimal"
            ],
            "standalone": true
          },
          "tags": [
            "dialog",
            "sheet",
            "popover",
            "alert-dialog",
            "overlay",
            "modal"
          ],
          "complexity": "high"
        }
      ]
    },
    {
      "id": "hero",
      "label": "Hero Sections",
      "description": "Gradient, image, video, split, minimal, and welcome hero layouts",
      "blocks": [
        {
          "id": "hero-gradient",
          "category": "hero",
          "description": "Full-viewport hero section with animated gradient orbs, staggered text reveals, dual CTAs, and social proof strip",
          "rendererTypes": [
            "avatar",
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "feature-grid",
              "feature-bento",
              "cta-banner",
              "testimonial-grid"
            ],
            "standalone": true
          },
          "tags": [
            "hero",
            "gradient",
            "landing",
            "cta",
            "social-proof",
            "blur-orb",
            "animation",
            "stagger"
          ],
          "complexity": "medium"
        },
        {
          "id": "hero-image",
          "category": "hero",
          "description": "Hero with a full-width background image, gradient overlay from bottom, and centered content with headline and CTAs.",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "image",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "feature-grid",
              "feature-bento",
              "cta-banner",
              "testimonial-grid"
            ],
            "standalone": true
          },
          "tags": [
            "hero",
            "background-image",
            "overlay",
            "gradient",
            "landing",
            "cta",
            "animation"
          ],
          "complexity": "medium"
        },
        {
          "id": "hero-image-ecommerce",
          "category": "hero",
          "description": "Hero with a full-width background image, gradient overlay from bottom, and centered content with headline and CTAs.",
          "rendererTypes": [
            "button",
            "container",
            "gradient",
            "icon",
            "image",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "hero",
            "background-image",
            "overlay",
            "gradient",
            "landing",
            "cta",
            "animation"
          ],
          "complexity": "complex"
        },
        {
          "id": "hero-image-restaurant",
          "category": "hero",
          "description": "Hero with a full-width background image, gradient overlay from bottom, and centered content with headline and CTAs.",
          "rendererTypes": [
            "button",
            "container",
            "gradient",
            "icon",
            "image",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "hero",
            "background-image",
            "overlay",
            "gradient",
            "landing",
            "cta",
            "animation"
          ],
          "complexity": "complex"
        },
        {
          "id": "hero-minimal",
          "category": "hero",
          "description": "Clean minimal hero with large centered headline, one-line description, and a single prominent CTA. Maximum whitespace, no decorations.",
          "rendererTypes": [
            "button",
            "container",
            "section",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "feature-grid",
              "feature-bento",
              "cta-banner",
              "testimonial-grid"
            ],
            "standalone": true
          },
          "tags": [
            "hero",
            "minimal",
            "clean",
            "centered",
            "landing",
            "simple"
          ],
          "complexity": "low"
        },
        {
          "id": "hero-split",
          "category": "hero",
          "description": "Split-layout hero with text and badge on the left, mockup illustration on the right. Responsive grid collapses to single column on mobile.",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "feature-grid",
              "feature-bento",
              "cta-banner",
              "testimonial-grid"
            ],
            "standalone": true
          },
          "tags": [
            "hero",
            "split",
            "grid",
            "landing",
            "cta",
            "illustration",
            "animation"
          ],
          "complexity": "high"
        },
        {
          "id": "hero-video",
          "category": "hero",
          "description": "Full-viewport hero with video background placeholder, dark overlay, centered headline, and animated play button CTA.",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "feature-grid",
              "feature-bento",
              "cta-banner",
              "testimonial-grid"
            ],
            "standalone": true
          },
          "tags": [
            "hero",
            "video",
            "overlay",
            "landing",
            "cta",
            "play-button",
            "dark"
          ],
          "complexity": "medium"
        },
        {
          "id": "showcase-hero",
          "category": "hero",
          "description": "Hero section for UI Component Showcase with gradient orbs, badge, staggered text reveals",
          "rendererTypes": [
            "badge",
            "container",
            "section",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "feature-grid",
              "feature-bento",
              "cta-banner",
              "testimonial-grid"
            ],
            "standalone": true
          },
          "tags": [
            "hero",
            "showcase",
            "components",
            "blur-orb",
            "gradient"
          ],
          "complexity": "low"
        },
        {
          "id": "survey-welcome",
          "category": "hero",
          "description": "Survey welcome page with intro and start button",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "separator",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "hero",
            "survey",
            "welcome"
          ],
          "complexity": "complex"
        }
      ]
    },
    {
      "id": "marketplace",
      "label": "Marketplace",
      "description": "marketplace components",
      "blocks": [
        {
          "id": "chat-conversation",
          "category": "marketplace",
          "description": "Chat conversation view with message bubbles, inline product card, offer/counter-offer buttons, image sharing, and typing indicator",
          "rendererTypes": [
            "avatar",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "text",
            "textarea"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "marketplace",
            "chat",
            "conversation",
            "messages",
            "offer",
            "product"
          ],
          "complexity": "complex"
        },
        {
          "id": "chat-inbox",
          "category": "marketplace",
          "description": "Message inbox with conversation threads, last message preview, unread badges, online status indicators, and search",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "input",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "marketplace",
            "chat",
            "inbox",
            "messages",
            "threads",
            "unread"
          ],
          "complexity": "complex"
        },
        {
          "id": "marketplace-home",
          "category": "marketplace",
          "description": "Marketplace home with search bar, category pills, featured items carousel, and trending items grid",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "input",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "marketplace",
            "home",
            "featured",
            "trending",
            "categories",
            "search"
          ],
          "complexity": "complex"
        },
        {
          "id": "product-browse",
          "category": "marketplace",
          "description": "Product browse page with grid/list toggle, filter sidebar (price, category, condition, location), sort dropdown, and product cards",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "image",
            "section",
            "select",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "marketplace",
            "browse",
            "filter",
            "sort",
            "grid",
            "list",
            "search"
          ],
          "complexity": "complex"
        },
        {
          "id": "product-listing",
          "category": "marketplace",
          "description": "Product listing detail with multi-image carousel, price, condition badge, seller info, description, and action buttons",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "marketplace",
            "product",
            "listing",
            "detail",
            "seller",
            "carousel",
            "condition"
          ],
          "complexity": "complex"
        },
        {
          "id": "review-section",
          "category": "marketplace",
          "description": "Review section with star rating breakdown, review cards with photos, write review form, and helpful votes",
          "rendererTypes": [
            "container",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "marketplace",
            "reviews",
            "rating",
            "stars",
            "feedback",
            "photos"
          ],
          "complexity": "medium"
        },
        {
          "id": "seller-profile",
          "category": "marketplace",
          "description": "Seller profile page with shop header, rating, product grid, reviews summary, follow button, and share",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "marketplace",
            "seller",
            "profile",
            "shop",
            "rating",
            "products",
            "follow"
          ],
          "complexity": "complex"
        }
      ]
    },
    {
      "id": "navigation",
      "label": "Navigation",
      "description": "Navbars, sidebars, breadcrumbs, headers, and settings navigation",
      "blocks": [
        {
          "id": "breadcrumb-nav",
          "category": "navigation",
          "description": "Breadcrumb navigation trail with home icon, chevron separators between items, and current page highlighted. Fades in on mount.",
          "rendererTypes": [
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "hero-gradient",
              "hero-split",
              "hero-minimal"
            ],
            "standalone": true
          },
          "tags": [
            "breadcrumb",
            "navigation",
            "path",
            "trail",
            "wayfinding"
          ],
          "complexity": "low"
        },
        {
          "id": "dashboard-header",
          "category": "navigation",
          "description": "Top bar header with breadcrumb, search input, notifications, and user avatar with dropdown trigger",
          "rendererTypes": [
            "avatar",
            "breadcrumb",
            "container",
            "icon",
            "input",
            "separator"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "hero-gradient",
              "hero-split",
              "hero-minimal"
            ],
            "standalone": true
          },
          "tags": [
            "header",
            "topbar",
            "breadcrumb",
            "search",
            "avatar",
            "dashboard"
          ],
          "complexity": "medium"
        },
        {
          "id": "dashboard-sidebar",
          "category": "navigation",
          "description": "Fixed vertical sidebar navigation with brand logo, icon nav items, active state, and dark-themed background",
          "rendererTypes": [
            "avatar",
            "container",
            "icon",
            "separator",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "hero-gradient",
              "hero-split",
              "hero-minimal"
            ],
            "standalone": true
          },
          "tags": [
            "sidebar",
            "navigation",
            "dashboard",
            "fixed",
            "dark"
          ],
          "complexity": "medium"
        },
        {
          "id": "landing-nav",
          "category": "navigation",
          "description": "Sticky landing page navigation with backdrop blur, responsive mobile menu, brand logo, ghost nav links, and dual CTA buttons.",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "link",
            "section",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "navigation",
            "landing",
            "nav",
            "header",
            "sticky",
            "responsive"
          ],
          "complexity": "medium"
        },
        {
          "id": "navbar-centered",
          "category": "navigation",
          "description": "Centered-logo navigation bar with nav links split left and right of logo, CTA button on far right, hover underline on links, and fade-in mount animation",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "hero-gradient",
              "hero-split",
              "hero-minimal"
            ],
            "standalone": true
          },
          "tags": [
            "navbar",
            "navigation",
            "centered",
            "logo",
            "links",
            "header"
          ],
          "complexity": "medium"
        },
        {
          "id": "navbar-floating",
          "category": "navigation",
          "description": "Floating sticky navbar with backdrop blur, responsive hamburger menu, logo, nav links, and CTA button",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "hero-gradient",
              "hero-split",
              "hero-minimal"
            ],
            "standalone": true
          },
          "tags": [
            "navbar",
            "navigation",
            "floating",
            "sticky",
            "backdrop-blur",
            "responsive",
            "hamburger"
          ],
          "complexity": "medium"
        },
        {
          "id": "settings-nav",
          "category": "navigation",
          "description": "Settings navigation sidebar with grouped sections (Account, Workspace, Advanced) using $ref definitions",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "separator",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "navigation",
            "saas",
            "settings",
            "nav",
            "sidebar",
            "grouped"
          ],
          "complexity": "complex"
        },
        {
          "id": "showcase-navigation",
          "category": "navigation",
          "description": "Navigation components showcase with breadcrumb, tabs, carousel, collapsible, pagination, and accordion",
          "rendererTypes": [
            "accordion",
            "badge",
            "breadcrumb",
            "button",
            "carousel",
            "collapsible",
            "container",
            "icon",
            "pagination",
            "section",
            "tab-trigger",
            "tabs",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "hero-gradient",
              "hero-split",
              "hero-minimal"
            ],
            "standalone": true
          },
          "tags": [
            "breadcrumb",
            "tabs",
            "carousel",
            "collapsible",
            "pagination",
            "navigation"
          ],
          "complexity": "high"
        },
        {
          "id": "survey-header",
          "category": "navigation",
          "description": "Survey header with progress indicator and theme switcher",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "navigation",
            "survey",
            "header"
          ],
          "complexity": "medium"
        },
        {
          "id": "todo-header",
          "category": "navigation",
          "description": "Todo app navigation header with task count badge and theme switcher",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "navigation",
            "todo",
            "header"
          ],
          "complexity": "medium"
        }
      ]
    },
    {
      "id": "portfolio",
      "label": "Portfolio",
      "description": "Gallery, project, hero, contact, resume, timeline, and skill components",
      "blocks": [
        {
          "id": "contact",
          "category": "portfolio",
          "description": "Contact page with two-column layout: contact info (email, phone, address, office hours, social links) and contact form",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "form",
            "icon",
            "input",
            "label",
            "section",
            "separator",
            "text",
            "textarea"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-minimal",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "portfolio",
            "contact",
            "form",
            "social-links",
            "email",
            "address"
          ],
          "complexity": "high"
        },
        {
          "id": "portfolio-contact",
          "category": "portfolio",
          "description": "Portfolio contact section with split layout. Left side shows contact info (email, location, social links). Right side has a contact form with name, email, subject, message, and send button.",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "form",
            "icon",
            "input",
            "label",
            "link",
            "section",
            "separator",
            "text",
            "textarea"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-minimal",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "portfolio",
            "contact",
            "form",
            "email",
            "social",
            "split-layout"
          ],
          "complexity": "high"
        },
        {
          "id": "portfolio-detail",
          "category": "portfolio",
          "description": "Project case study page with hero image, project metadata, description sections, tech stack badges, and prev/next navigation",
          "rendererTypes": [
            "badge",
            "container",
            "icon",
            "image",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-minimal",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "portfolio",
            "case-study",
            "project",
            "detail",
            "tech-stack",
            "navigation"
          ],
          "complexity": "high"
        },
        {
          "id": "portfolio-gallery",
          "category": "portfolio",
          "description": "Portfolio project gallery with filter tabs (All, Web, Mobile, Design) and project cards displaying image, title, tech stack tags, and hover overlay with view link.",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-minimal",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "portfolio",
            "gallery",
            "projects",
            "filter",
            "grid",
            "showcase"
          ],
          "complexity": "high"
        },
        {
          "id": "portfolio-grid",
          "category": "portfolio",
          "description": "Project showcase grid with filter tabs, hover overlay, and staggered animation",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-minimal",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "portfolio",
            "grid",
            "projects",
            "filter",
            "masonry",
            "hover"
          ],
          "complexity": "high"
        },
        {
          "id": "portfolio-hero",
          "category": "portfolio",
          "description": "Portfolio hero section. Large name display, role/title, brief intro text, CTA buttons (View Work and Contact), and a subtle animated dot-pattern or blur-orb background decoration.",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "link",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-minimal",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "portfolio",
            "hero",
            "personal",
            "intro",
            "cta",
            "developer"
          ],
          "complexity": "medium"
        },
        {
          "id": "portfolio-project",
          "category": "portfolio",
          "description": "Single project detail page. Hero image, project title and metadata (client, date, role), description text, tech stack badges, secondary image gallery, and live/github action buttons.",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-minimal",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "portfolio",
            "project",
            "case-study",
            "detail",
            "tech-stack",
            "gallery"
          ],
          "complexity": "high"
        },
        {
          "id": "resume",
          "category": "portfolio",
          "description": "Resume/CV page with profile header, timeline experience, education, skills bars, and certifications. Scroll-triggered per section.",
          "rendererTypes": [
            "avatar",
            "button",
            "container",
            "icon",
            "progress",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-minimal",
              "cta-gradient"
            ],
            "standalone": false
          },
          "tags": [
            "portfolio",
            "resume",
            "cv",
            "experience",
            "skills",
            "timeline"
          ],
          "complexity": "high"
        },
        {
          "id": "skill-bars",
          "category": "portfolio",
          "description": "Animated skill bars with hover-reveal percentages, grouped by Frontend and Backend categories. Based on Skills Showcase from 21st.dev.",
          "rendererTypes": [
            "badge",
            "card",
            "container",
            "icon",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "portfolio",
            "skills",
            "progress",
            "bars",
            "animated"
          ],
          "complexity": "complex"
        },
        {
          "id": "timeline",
          "category": "portfolio",
          "description": "Vertical timeline with animated connector dots, filter tabs (All/Work/Education), and hover-lift cards showing role, company, date, location, and skill tags.",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "portfolio",
            "timeline",
            "experience",
            "education"
          ],
          "complexity": "complex"
        }
      ]
    },
    {
      "id": "pricing",
      "label": "Pricing",
      "description": "Pricing cards, comparison tables, toggle, and FAQ sections",
      "blocks": [
        {
          "id": "pricing-cards",
          "category": "pricing",
          "description": "Static 3-tier pricing cards (Hobby, Pro, Business) with feature lists, CTA buttons, middle card highlighted with border-primary, and staggered scroll animations",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "feature-comparison",
              "cta-gradient",
              "pricing-faq"
            ],
            "standalone": false
          },
          "tags": [
            "pricing",
            "plans",
            "cards",
            "static",
            "tiers",
            "features"
          ],
          "complexity": "high"
        },
        {
          "id": "pricing-comparison",
          "category": "pricing",
          "description": "Feature comparison table with features as rows and pricing tiers as columns, check/x/dash indicators, sticky-style header row with tier names, and scroll-triggered fade animation",
          "rendererTypes": [
            "badge",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "feature-comparison",
              "cta-gradient",
              "pricing-faq"
            ],
            "standalone": false
          },
          "tags": [
            "pricing",
            "comparison",
            "table",
            "features",
            "tiers",
            "matrix"
          ],
          "complexity": "high"
        },
        {
          "id": "pricing-faq",
          "category": "pricing",
          "description": "Pricing-specific FAQ section using native accordion component with 6 common pricing questions, staggered scroll-trigger animations",
          "rendererTypes": [
            "accordion",
            "badge",
            "container",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "feature-comparison",
              "cta-gradient",
              "pricing-faq"
            ],
            "standalone": false
          },
          "tags": [
            "pricing",
            "faq",
            "accordion",
            "questions",
            "answers"
          ],
          "complexity": "medium"
        },
        {
          "id": "pricing-toggle",
          "category": "pricing",
          "description": "3-tier pricing section with monthly/annual toggle, expression-bound prices, featured Pro tier, staggered card enter animation, hover lift interaction, and responsive grid.",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "section",
            "separator",
            "switch",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "feature-comparison",
              "cta-gradient",
              "pricing-faq"
            ],
            "standalone": false
          },
          "tags": [
            "pricing",
            "toggle",
            "tiers",
            "billing",
            "annual",
            "responsive-grid",
            "featured",
            "saas"
          ],
          "complexity": "high"
        }
      ]
    },
    {
      "id": "productivity",
      "label": "Productivity",
      "description": "Task lists, task details, and task row components for todo apps",
      "blocks": [
        {
          "id": "task-detail",
          "category": "productivity",
          "description": "Task detail page with title, description, priority, and subtask checkboxes",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "productivity",
            "task",
            "detail"
          ],
          "complexity": "complex"
        },
        {
          "id": "task-list",
          "category": "productivity",
          "description": "Main task list with add input, filter badges, and task rows via block-ref",
          "rendererTypes": [
            "badge",
            "block-ref",
            "button",
            "container",
            "icon",
            "input",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "productivity",
            "task",
            "list"
          ],
          "complexity": "complex"
        },
        {
          "id": "task-row",
          "category": "productivity",
          "description": "Individual task row with completion switch, priority badge, and delete button",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "productivity",
            "task",
            "row"
          ],
          "complexity": "medium"
        }
      ]
    },
    {
      "id": "real-estate",
      "label": "Real Estate",
      "description": "Property heroes, search, and listing components for real estate",
      "blocks": [
        {
          "id": "hero-property",
          "category": "real-estate",
          "description": "hero-property block",
          "rendererTypes": [
            "button",
            "container",
            "gradient",
            "icon",
            "image",
            "input",
            "section",
            "text"
          ],
          "composability": {
            "position": "top",
            "pairs_with": [
              "footer-minimal"
            ],
            "standalone": false
          },
          "tags": [
            "hero",
            "real-estate",
            "search",
            "property"
          ],
          "complexity": "complex"
        }
      ]
    },
    {
      "id": "saas",
      "label": "SaaS",
      "description": "Dashboard, analytics, billing, onboarding, settings, team, and account pages",
      "blocks": [
        {
          "id": "account-settings",
          "category": "saas",
          "description": "Account settings page with profile card (avatar, name, email), password change card, and danger zone (delete account confirmation).",
          "rendererTypes": [
            "avatar",
            "button",
            "card",
            "container",
            "icon",
            "input",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "saas",
            "auth",
            "account",
            "settings",
            "profile",
            "password",
            "avatar",
            "danger-zone"
          ],
          "complexity": "complex"
        },
        {
          "id": "saas-analytics",
          "category": "saas",
          "description": "Analytics dashboard with date range selector, large chart card, metric comparison cards, and data table",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "dashboard-sidebar",
              "dashboard-header"
            ],
            "standalone": false
          },
          "tags": [
            "saas",
            "analytics",
            "dashboard",
            "chart",
            "metrics",
            "data"
          ],
          "complexity": "high"
        },
        {
          "id": "saas-billing",
          "category": "saas",
          "description": "Billing management page with current plan card, payment method, and invoice history table",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "icon",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "dashboard-sidebar",
              "dashboard-header"
            ],
            "standalone": false
          },
          "tags": [
            "saas",
            "billing",
            "subscription",
            "invoice",
            "payment",
            "admin"
          ],
          "complexity": "high"
        },
        {
          "id": "saas-dashboard",
          "category": "saas",
          "description": "SaaS admin dashboard overview with metric stat cards, line chart area, and recent activity feed",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "dashboard-sidebar",
              "dashboard-header"
            ],
            "standalone": false
          },
          "tags": [
            "saas",
            "dashboard",
            "metrics",
            "chart",
            "analytics",
            "admin"
          ],
          "complexity": "high"
        },
        {
          "id": "saas-onboarding",
          "category": "saas",
          "description": "Onboarding stepper with 4 steps (Profile, Team, Integrations, Done), step content card, and Back/Next navigation",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "input",
            "label",
            "section",
            "select",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "dashboard-sidebar",
              "dashboard-header"
            ],
            "standalone": false
          },
          "tags": [
            "saas",
            "onboarding",
            "stepper",
            "wizard",
            "setup",
            "flow"
          ],
          "complexity": "high"
        },
        {
          "id": "saas-settings",
          "category": "saas",
          "description": "Settings page with sidebar navigation tabs and right panel form for Profile, Notifications, Security, and Billing sections",
          "rendererTypes": [
            "avatar",
            "button",
            "container",
            "form",
            "icon",
            "input",
            "label",
            "section",
            "separator",
            "text",
            "textarea"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "dashboard-sidebar",
              "dashboard-header"
            ],
            "standalone": false
          },
          "tags": [
            "saas",
            "settings",
            "profile",
            "form",
            "navigation",
            "admin"
          ],
          "complexity": "high"
        },
        {
          "id": "saas-team",
          "category": "saas",
          "description": "Team management page with member list (avatar, name, role badge, actions), invite form, and role filter",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "dashboard-sidebar",
              "dashboard-header"
            ],
            "standalone": false
          },
          "tags": [
            "saas",
            "team",
            "members",
            "invite",
            "roles",
            "admin"
          ],
          "complexity": "medium"
        }
      ]
    },
    {
      "id": "social",
      "label": "Social",
      "description": "Feed, profile, chat, comment, share, post, and story bar components",
      "blocks": [
        {
          "id": "social-chat",
          "category": "social",
          "description": "Chat and messaging interface. Conversation list sidebar with online indicators, active chat area with sent/received message bubbles, and message input with send button.",
          "rendererTypes": [
            "avatar",
            "button",
            "container",
            "icon",
            "input",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-social"
            ],
            "standalone": false
          },
          "tags": [
            "social",
            "chat",
            "messaging",
            "conversation",
            "realtime",
            "inbox"
          ],
          "complexity": "high"
        },
        {
          "id": "social-comment",
          "category": "social",
          "description": "Comment thread with nested replies, like counts, reply buttons, and show-more expansion",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "input",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-social"
            ],
            "standalone": false
          },
          "tags": [
            "social",
            "comment",
            "reply",
            "thread",
            "nested",
            "discussion"
          ],
          "complexity": "high"
        },
        {
          "id": "social-feed",
          "category": "social",
          "description": "Social media feed with post cards (avatar, text, image, like/comment/share row) and new post input",
          "rendererTypes": [
            "avatar",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "text",
            "textarea"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-social"
            ],
            "standalone": false
          },
          "tags": [
            "social",
            "feed",
            "posts",
            "like",
            "comment",
            "timeline"
          ],
          "complexity": "high"
        },
        {
          "id": "social-post",
          "category": "social",
          "description": "New post composer. Avatar and textarea prompt, media attach buttons (image, video, poll), character count indicator, and post submit button.",
          "rendererTypes": [
            "avatar",
            "button",
            "container",
            "icon",
            "section",
            "separator",
            "text",
            "textarea"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-social"
            ],
            "standalone": false
          },
          "tags": [
            "social",
            "post",
            "compose",
            "create",
            "textarea",
            "media"
          ],
          "complexity": "medium"
        },
        {
          "id": "social-profile",
          "category": "social",
          "description": "User profile page with cover image, avatar, name, bio, follower stats, tab bar, and edit button",
          "rendererTypes": [
            "avatar",
            "button",
            "container",
            "icon",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-social"
            ],
            "standalone": false
          },
          "tags": [
            "social",
            "profile",
            "user",
            "avatar",
            "cover",
            "followers"
          ],
          "complexity": "medium"
        },
        {
          "id": "social-share",
          "category": "social",
          "description": "Share dialog content with social platform buttons, link preview card, and copy URL input",
          "rendererTypes": [
            "button",
            "container",
            "icon",
            "image",
            "input",
            "label",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "navbar-floating",
              "footer-social"
            ],
            "standalone": false
          },
          "tags": [
            "social",
            "share",
            "copy",
            "link",
            "dialog",
            "platforms"
          ],
          "complexity": "medium"
        },
        {
          "id": "story-bar",
          "category": "social",
          "description": "Horizontal scrollable story bar with gradient-ring avatars, your-story creation, LIVE badges, and Embla-style carousel navigation",
          "rendererTypes": [
            "avatar",
            "badge",
            "container",
            "icon",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "social",
            "story",
            "bar",
            "carousel",
            "avatar",
            "live"
          ],
          "complexity": "complex"
        }
      ]
    },
    {
      "id": "task-manager",
      "label": "Task-manager",
      "description": "task-manager components",
      "blocks": [
        {
          "id": "activity-log",
          "category": "task-manager",
          "description": "Chronological activity feed showing task changes (created, completed, commented, assigned) with filter by type and user",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "input",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "task-manager",
            "activity",
            "log"
          ],
          "complexity": "complex"
        },
        {
          "id": "calendar-view",
          "category": "task-manager",
          "description": "Monthly/weekly calendar grid with event blocks, color coding by priority, date navigation, and add event capabilities",
          "rendererTypes": [
            "badge",
            "button",
            "container",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "task-manager",
            "calendar",
            "view"
          ],
          "complexity": "complex"
        },
        {
          "id": "kanban-board",
          "category": "task-manager",
          "description": "Drag-and-drop kanban board with customizable columns (To Do, In Progress, Review, Done), task cards with priority and assignee, and add column/task capabilities",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "task-manager",
            "kanban",
            "board"
          ],
          "complexity": "complex"
        },
        {
          "id": "project-overview",
          "category": "task-manager",
          "description": "Project dashboard with stats cards (total tasks, completion %, overdue), progress visualization, recent activity feed, and milestone timeline",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "task-manager",
            "project",
            "overview"
          ],
          "complexity": "complex"
        },
        {
          "id": "task-detail",
          "category": "task-manager",
          "description": "Task detail view with title, description editor, status selector, priority, assignee, due date, comments thread, and subtask checklist",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "input",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "task-manager",
            "task",
            "detail"
          ],
          "complexity": "complex"
        },
        {
          "id": "task-list-view",
          "category": "task-manager",
          "description": "Task list with checkboxes, priority badges (P0-P3), due dates, assignee avatars, and filter/sort controls",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "input",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "task-manager",
            "task",
            "list",
            "view"
          ],
          "complexity": "complex"
        },
        {
          "id": "team-members",
          "category": "task-manager",
          "description": "Team members grid with avatars, role badges, task count, online status indicator, and invite member functionality",
          "rendererTypes": [
            "avatar",
            "badge",
            "button",
            "container",
            "icon",
            "input",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "footer-minimal",
              "navbar-floating"
            ],
            "standalone": false
          },
          "tags": [
            "task-manager",
            "team",
            "members"
          ],
          "complexity": "complex"
        }
      ]
    },
    {
      "id": "testimonial",
      "label": "Testimonials",
      "description": "Avatar, carousel, grid, and quote testimonial layouts",
      "blocks": [
        {
          "id": "testimonial-avatar",
          "category": "testimonial",
          "description": "Avatar-focused testimonial row with horizontal avatar circles, names, hover scale interaction, and expanded featured quote below the selected avatar",
          "rendererTypes": [
            "badge",
            "container",
            "icon",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "cta-gradient",
              "pricing-toggle",
              "footer-multi-column"
            ],
            "standalone": false
          },
          "tags": [
            "testimonial",
            "avatars",
            "interactive",
            "hover",
            "social-proof"
          ],
          "complexity": "medium"
        },
        {
          "id": "testimonial-carousel",
          "category": "testimonial",
          "description": "Social proof testimonial section with 3-column grid, star ratings, avatars, stats bar, staggered scroll-triggered animations, and card hover micro-interactions",
          "rendererTypes": [
            "badge",
            "container",
            "icon",
            "image",
            "section",
            "separator",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "cta-gradient",
              "pricing-toggle",
              "footer-multi-column"
            ],
            "standalone": false
          },
          "tags": [
            "testimonial",
            "social-proof",
            "reviews",
            "cards",
            "grid",
            "ratings",
            "stats"
          ],
          "complexity": "high"
        },
        {
          "id": "testimonial-grid",
          "category": "testimonial",
          "description": "Static 3-column testimonial grid with 6 testimonials, avatar, name, role, star ratings, and staggered scroll-triggered animations",
          "rendererTypes": [
            "badge",
            "container",
            "icon",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "cta-gradient",
              "pricing-toggle",
              "footer-multi-column"
            ],
            "standalone": false
          },
          "tags": [
            "testimonial",
            "social-proof",
            "reviews",
            "grid",
            "ratings",
            "avatars"
          ],
          "complexity": "high"
        },
        {
          "id": "testimonial-quote",
          "category": "testimonial",
          "description": "Large featured single-quote testimonial with oversized decorative quotation mark, avatar, full quote text, name, role, company logo, subtle gradient background, and scale-in animation",
          "rendererTypes": [
            "container",
            "icon",
            "image",
            "section",
            "text"
          ],
          "composability": {
            "position": "middle",
            "pairs_with": [
              "cta-gradient",
              "pricing-toggle",
              "footer-multi-column"
            ],
            "standalone": false
          },
          "tags": [
            "testimonial",
            "quote",
            "featured",
            "social-proof",
            "single",
            "large"
          ],
          "complexity": "medium"
        }
      ]
    }
  ]
}
